import * as React from 'react'

import './styles.scss'
import { configurations } from '../../api'
import { BrandsAndDelegations, Button, ButtonTag, SelectWithLabel } from 'components/Form'
import ModalChannelList from './ModalChannelList'
import ColorPickerInput from 'components/ColorPickerInput'
import { channelName, chatmailProviders } from 'constants/channels'
import FileUploaderLogo from './Channels/fields/fileUploaderLogo'
import ModalPosterQR from './ModalPosterQR'
import { lang } from 'utils/helpers'
const _ = require('lodash')

const QRCodeWidgetCreator = (props) => {
  const { channels, dataToEdit, setDataToEdit, dataCloneWebWidgetToQr } = props
  const [channelList, setChannelList] = React.useState(channels || [])
  const [channel, setChannel] = React.useState([])
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [order, setOrder] = React.useState({ value: 'asc', label: lang('order_by_az') })
  const [channelColor, setChannelColor] = React.useState('#E87721')
  const [selectedChannels, setSelectedChannels] = React.useState([])
  const [name, setName] = React.useState('')
  const [valueLogo, setValueLogo] = React.useState('')
  const [phrase, setPhrase] = React.useState(lang('channels_qr_default_phrase'))
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [isOpenPosterQR, setIsOpenPosterQR] = React.useState(false)
  const [detailsInfoPosterQr, setDetailsInfoPosterQR] = React.useState({})
  const [errorMessage, setErrorMessage] = React.useState('')
  const [errorMessageName, setErrorMessageName] = React.useState('')
  const [errorMessagePhrase, setErrorMessagePhrase] = React.useState('')
  const [errorLogoEdit, setErrorLogoEdit] = React.useState('')
  const qrPosterApi = configurations.channels
  const orderField = { value: 'channel' }
  const dimensions = { height: 512, width: 512, withRelation: '1:1' }
  const channelOptions = _.filter(_.map(channelName, (value, key) => ({
    label: lang(value.name),
    value: key,
    notShow: value.notShow,
    order: value.order
  })), (it) => !it.notShow && it.value !== 'wall').sort((a, b) => a.order - b.order)

  React.useEffect(() => {
    getChannels(brands, delegations, channel)
  }, [brands, delegations, channel])

  React.useEffect(() => {
    let _channels = []
    let _channelList = _.cloneDeep(channelList)
    if (dataCloneWebWidgetToQr) {
      fillDataClone(dataCloneWebWidgetToQr)
      dataCloneWebWidgetToQr.channels.forEach(it => {
        channels.forEach(it2 => {
          if (it2._id === it.identifier) {
            it2['isChecked'] = true
            _channels.push({ ...it2 })
          }
        })
      })
    }
    handleSelectedChannels(_channels)
    setChannelList(_channelList)
  }, [dataCloneWebWidgetToQr])

  React.useEffect(() => {
    if (!dataCloneWebWidgetToQr) {
      channels.forEach(it => { it['isChecked'] = null })
    }
    setChannelList(channels)
  }, [channels])

  React.useEffect(() => {
    if (dataToEdit) {
      handleName(dataToEdit?.name)
      setChannelColor(dataToEdit?.color)
      setValueLogo(dataToEdit?.logoUrl || '')
      let _channels = []
      let _channelList = _.cloneDeep(channelList)
      dataToEdit.channels.forEach(it => {
        _channelList.forEach(it2 => {
          if (it2._id === it.identifier) {
            it2['isChecked'] = true
            _channels.push({ ...it2 })

          }
        })
      })
      handleSelectedChannels(_channels)
      setChannelList(_channelList)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToEdit])

  const handleName = (value) => {
    setName(value)
    setErrorMessageName('')
  }

  const handlePhrase = (value) => {
    setPhrase(value)
    setErrorMessagePhrase('')
  }

  const handleSelectedChannels = (value) => {
    setSelectedChannels(value)
    setErrorMessage('')
  }

  const onChangeLogo = (value, _prop) => {
    if (value === '' || value === undefined) setValueLogo('')
    else setValueLogo(value)
  }

  const fillDataClone = (cloneData) => {
    handleName(cloneData.name)
    setChannelColor(cloneData.primaryColor)
  }

  const onChange = (value, type) => {
    if (type === 'brand') {
      setBrands(value[0]?.value ? value : [])
      setDelegations([])
    }
    else if (type === 'delegation') {
      setDelegations(value[0]?.value ? value : [])
    }
    else if (type === 'order') {
      setOrder(value)
      setChannelsAndOrder(channelList, value)
    }
    else if (type === 'channel') {
      setChannel(value[0]?.value ? value : [])
    }
  }

  const getChannels = (_brands, _delegations, _channel) => {
    let _channelList = _.clone(channels)
    if (_brands.length > 0) {
      _channelList = _channelList.filter(it => it.brandDefault === _brands[0].value)
    }
    if (_delegations.length > 0) {
      _channelList = _channelList.filter(it => it.delegationDefault === _delegations[0].value)
    }
    if (_channel.length > 0) {
      if (_channel[0].value === 'chatmail') _channelList = _channelList.filter(it => chatmailProviders.includes(it.key))
      else if (_channel[0]?.value === 'whatsapp_whatsapp') _channelList = _channelList.filter(it => it.hub === 'whatsapp')
      else if (_channel[0]?.value === 'whatsapp') _channelList = _channelList.filter(it => it.key === _channel[0]?.value && it.hub === 'twilio')
      else _channelList = _channelList.filter(it => it.key === _channel[0].value || it.value.connectionType === _channel[0].value)
    }
    setChannelsAndOrder(_channelList)
  }

  const setChannelsAndOrder = (_channels = channelList, _order = order, _orderField = orderField) => {
    setChannelList(_channels)
  }

  const clearChannels = () => {
    setIsSubmitting(false)
    setChannel([])
    setBrands([])
    setDelegations([])
    setChannelList(channels)
  }

  const createPosterQr = async () => {
    let error = false
    if (selectedChannels.length === 0) {
      setErrorMessage(lang('channels_message_select_one_channel'))
      error = true
    }
    if (!name) {
      setErrorMessageName(lang('channels_message_no_name'))
      error = true
    }
    if (phrase && phrase.length > 35) {
      setErrorMessagePhrase(lang('channels_message_phrase_error'))
      error = true
    }
    const config = {
      color: channelColor,
      phrase: phrase ? phrase : lang('channels_qr_default_phrase'),
      name,
      channels: selectedChannels.map((channel) => {
        return {
          name: channel.key,
          identifier: channel._id,
        }
      })
    }
    if (valueLogo === '' && !!dataToEdit && dataToEdit.logoUrl) {
      setErrorLogoEdit(lang('channels_message_no_logo_update'))
      error = true
    }
    if (valueLogo !== '') config.logoUrl = valueLogo
    if (error) return
    setIsSubmitting(true)
    try {
      if (!dataToEdit) {
        const response = await qrPosterApi.createQRPoster(config)
        if (response) {
          clearChannels()
          setDetailsInfoPosterQR(response.data)
          setIsOpenPosterQR(true)
        }
      } else {
        const response = await qrPosterApi.updateQRPoster(dataToEdit._id, config)
        if (response.data) { //devuelve true o false
          clearChannels()
          setDetailsInfoPosterQR(config)
          setIsOpenPosterQR(true)
        }
      }
    } catch (error) {
      setIsSubmitting(false)
      setErrorMessage(lang('channels_message_select_one_channel'))
    }
  }

  return (
    <div className='web-widget-create qr-poster'>
      <h1>{lang('channels_qr_title')}</h1>
      <legend>{lang('channels_qr_legend')}</legend>
      <div className='web-widget'>
        <div className='selectors'>
          <SelectWithLabel
            label={lang('dashboard_channel')}
            name='channel'
            key='channel'
            options={channelOptions}
            multi={false}
            value={channel}
            selectedValues={channel}
            onChange={(value) => onChange([value], 'channel')}
            placeholder={lang('dashboard_selector_filter-by-channel')}
            classNameWrapper='channel-selector'
            isClearable
          />
          <BrandsAndDelegations
            onChangeBrands={(value) => onChange([value], 'brand')}
            currentBrands={brands || []}
            onChangeDelegations={(value) => onChange([value], 'delegation')}
            currentDelegations={delegations || []}
            multi={false}
            labelInside
            displayAllValues={false}
            isClearable
          />
          <ButtonTag
            value={lang('dashboard_reset-filters')}
            className='qr-reset-filters'
            onClick={() => {
              setChannel([])
              setBrands([])
              setDelegations([])
            }}
          />
        </div>
        <div className='channel-list-container'>
          <ModalChannelList
            key={dataToEdit ? `channelList-${dataToEdit._id}` : 'channelList-0'}
            availableChannels={channelList}
            maxChannels={8}
            selectedChannels={selectedChannels}
            onSelected={data => {
              handleSelectedChannels(data)
            }}
          />
          {errorMessage && <span className='error-message'>{errorMessage}</span>}
        </div>
        <div className='wrapper-name-container'>
          <div className='name-container'>
            <label className='text-editor-title'>{lang('channels_qr_name')}</label>
            <input
              className='input-name'
              type={'text'}
              id={'name'}
              value={name}
              onChange={({ target }) => handleName(target.value)}
            />
            {errorMessageName && <span className='error-message'>{errorMessageName}</span>}
          </div>
        </div>

        <div className='wrapper-name-container'>
          <div className='name-container'>
            <FileUploaderLogo
              channel={channel}
              label='channels_qr_logo_label'
              required={false}
              acceptTypes={'image/png'}
              value={valueLogo}
              prop={"app.logo"}
              propName={'app_logo'}
              isOpenContainer={{ configuration: false, messages: false, resources: true }}
              onChange={onChangeLogo}
              restore={true}
              dimensions={dimensions}
              description='channels_qr_logo_deferred'
            />
            {errorLogoEdit && <span className='error-message'>{errorLogoEdit}</span>}
          </div>
        </div>

        <div className='wrapper-name-container qr-phrase'>
          <div className='name-container'>
            <label className='text-editor-title'>{lang('channels_qr_new_phrase')}</label>
            <input
              className='input-name'
              type={'text'}
              id={'phrase'}
              value={phrase}
              onChange={({ target }) => handlePhrase(target.value)}
              maxLength={35}
              max={35}
            />
            {errorMessagePhrase && <span className='error-message'>{errorMessagePhrase}</span>}
          </div>
          <div className='text-editor-container message-info-container'>
            <div className='message-config-container'>
              <p className='message-info'>{lang('channels_qr_deferred')}</p>
            </div>
          </div>
        </div>

        <div className='wrapper-name-container'>
          <div className='color-selector-container'>
            <div className='text-editor-title'>{lang('channels_web_widget_main_color')}</div>
            <ColorPickerInput color={channelColor} setColor={setChannelColor} />
          </div>
        </div>

        <div className='buttons-widgets'>
          <Button
            secondary
            value={dataToEdit ? lang('channels_button_edit_qr') : lang('channels_button_create_qr')}
            onClick={createPosterQr}
            isSubmitting={isSubmitting}
          />
          {dataToEdit ? (
            <Button
              value={lang('dashboard_cancel')}
              onClick={() => setDataToEdit(null)}
            />
          ) : null}
          {isOpenPosterQR && selectedChannels.length > 0 ? (
            <ModalPosterQR
              isOpen={isOpenPosterQR}
              toggle={() => {
                setIsOpenPosterQR(!isOpenPosterQR)
                if (dataToEdit) setDataToEdit(null)
              }}
              channels={selectedChannels}
              configPoster={detailsInfoPosterQr}
              isDisplay={true}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default QRCodeWidgetCreator
